import React, { Component } from 'react';
import PropTypes from 'prop-types';
import windowSize from 'react-window-size';

class View extends Component {
  splitIfSmartPhone(text) {
    const { windowWidth } = this.props;
    const SCREEN_SM = 576;
    const texts = [...text];
    if (windowWidth > SCREEN_SM || texts.length < 5) {
      return text;
    }
    texts.splice(-2, 0, <br />);
    return (
      texts.map((x) => <React.Fragment key={x}>{x}</React.Fragment>)
    );
  }

  render() {
    const { current, steps } = this.props;
    let notCompleted = false;
    return steps.filter((x) => x !== undefined).map((x) => {
      const result = (<li key={x.path} className={!notCompleted ? 'current' : null}>{this.splitIfSmartPhone(x.name)}</li>);
      if (x.path === current) {
        notCompleted = true;
      }
      return result;
    });
  }
}

View.defaultProps = {
  steps: [
    {
      path: 'new',
      name: 'プレエントリー情報',
    },
    {
      path: 'confirm',
      name: '確認',
    },
    {
      path: 'finished',
      name: '完了',
    },
  ],
};

View.propTypes = {
  current: PropTypes.string.isRequired,
  windowWidth: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })),
};

export default windowSize(View);
